import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { EnviromentGlobalService } from './enviroment-global.service';


@Injectable()
export class BasicasLoVService {
	private API_URL;

	constructor(private http: HttpClient, private enviromentGlobalService: EnviromentGlobalService) {
		this.API_URL = enviromentGlobalService.apiUrl;
	}

	getDepartamentos(entry: any): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/departamento`).pipe(
			retry(2)
		);
	}

	getMunicipios(entry: any): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/municipio`).pipe(
			retry(2)
		);
	}

	getMunicipiosxDepartamento(departamento_id: any): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/municipio/pordepartamento/${departamento_id}`).pipe(
			retry(2)
		);
	}

	getTiposIdentificacion(entry: any): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/tipoidentificacion`).pipe(
			retry(2)
		);
	}
}
